<h2>{{ 'profiles.search.title' | translate | titlecase }}</h2>

<div>
  <div class="mct-flex mct-row">
    <div class="mct-flex-0-0-200px"></div>
    <div class="atlas-keyword-search profile-search-flex">
      <div class="input-group">
        <input
          [(ngModel)]="profileSearchComponentModel.searchParams.Keyword"
          type="text"
          class="form-control"
          (keypress)="keywordKeypress($event)"
          placeholder="{{ 'profiles.search.keyword-placeholder' | translate | ucfirst }}"
        />
        <span class="input-group-btn">
          <button
            pButton
            type="button"
            class="atlas-btn atlas-btn-primary tall"
            icon="pi pi-search"
            [disabled]="isSearching"
            (click)="searchProfiles()"
          ></button>
        </span>
      </div>
    </div>

    <div class="col-sm-3" *ngIf="!alwaysExpandAdvancedSearch">
      <a (click)="handleShowAdvancedSearch()" *ngIf="!profileSearchComponentModel.showAdvancedSearch">
        {{ 'common.advanced' | translate | titlecase }} {{ 'common.search' | translate | titlecase }}
      </a>
      <a (click)="handleHideAdvancedSearch()" *ngIf="profileSearchComponentModel.showAdvancedSearch">
        {{ 'common.hide' | translate | titlecase }} {{ 'common.advanced' | translate | titlecase }}
        {{ 'common.search' | translate | titlecase }}
      </a>
    </div>
  </div>
  <div style="margin-bottom: 60px" [hidden]="!profileSearchComponentModel.showAdvancedSearch">
    <wl-profile-advanced-search-options
      [hidden]="!profileSearchComponentModel.showAdvancedSearch"
      [searchParams]="profileSearchComponentModel.searchParams"
      (searchClicked)="searchProfiles()"
    ></wl-profile-advanced-search-options>
  </div>
  <div [hidden]="runProfileSelectorAdvancedSearch || !showProfileSelectorGrid">
    <div class="atlas-profile-search-actions">
      <div class="mct-flex mct-row mct-gap-10">
        <div class="mct-justify-start mct-items-center mct-flex-1-1-100px">
          <action-button
            data-cy="btnProfileSearchActions"
            [label]="actionsText"
            [items]="actionsOptions"
            [menuStyle]="{ width: '325px', 'max-width': '85vw' }"
          >
          </action-button>
          <wl-busy [show]="isExporting"></wl-busy>
        </div>
        <div class="mct-flex mct-justify-end-gt-sm mct-items-center-gt-sm mct-gap-10 profile-search-flex mct-col-lt-sm" style="width: 100%">
          &nbsp;
          <div
            class="mct-flex mct-row mct-wrap mct-justify-start mct-items-center mct-flex-1-1-0"
            [hidden]="profileSearchComponentModel.selectedProfiles.length == 0 && !selectAll"
          >
            {{ 'profiles.search.there-are' | translate | ucfirst }}
            <span style="font-weight: bold" [hidden]="selectAll">
              &nbsp;{{ profileSearchComponentModel.selectedProfiles.length }} {{ 'profiles.search.tagged-profiles' | translate }}&nbsp;
            </span>
            <span style="font-weight: bold" [hidden]="!selectAll">
              &nbsp;{{ profileSearchComponentModel.profiles?.TotalCount - profileSearchComponentModel.selectedProfiles.length }}
              {{ 'profiles.search.tagged-profiles' | translate }}&nbsp;
            </span>
            {{ 'profiles.search.to-take-action' | translate }}
          </div>
          <div class="mct-flex mct-row mct-wrap mct-justify-end mct-items-center mct-flex-1-1-0">
            {{ 'profiles.search.search-returned' | translate | ucfirst }}&nbsp;
            <span style="font-weight: bold"
              >{{ profileSearchComponentModel.profiles?.TotalCount }}&nbsp;{{ 'profiles.search.total-profiles' | translate }}</span
            >
          </div>
        </div>
        <div class="ml-27 mct-justify-end mct-items-center mct-flex-1-0-300px">
          <button
            pButton
            type="button"
            class="atlas-btn atlas-btn-default"
            icon="pi pi-times"
            [label]="'profiles.search.clear' | translate | uppercase"
            (click)="clearProfiles()"
          ></button>
          <button
            pButton
            class="atlas-btn atlas-btn-primary"
            icon="pi pi-plus"
            [label]="'profiles.search.manage-columns.title' | translate | titlecase"
            (click)="manageColumnsComponent.showManageColumnsDialog()"
          ></button>
        </div>
      </div>
    </div>
    <div>
      <p-table
        [showGridlines]="true"
        data-cy="tableProfileSearchResults"
        #profilesDataGrid
        [lazy]="true"
        [rows]="20"
        [value]="profileSearchComponentModel.profiles?.Result"
        [paginator]="true"
        (onLazyLoad)="lazyLoadProfiles($event)"
        [totalRecords]="profileSearchComponentModel.profiles?.TotalCount"
        [sortField]="'ASF'"
      >
        <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
          <SortAltIcon *ngIf="sortOrder === 0">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
          </SortAltIcon>
          <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
          </SortAmountUpAltIcon>
          <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
            <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
          </SortAmountDownIcon>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th class="text-center" style="width: 40px" [hidden]="singleProfileSelect">
              <input
                [(ngModel)]="profileSearchComponentModel.selectAllProfiles"
                (ngModelChange)="onSelectAllChange(profileSearchComponentModel.selectAllProfiles)"
                type="checkbox"
              />
            </th>
            <th [pSortableColumn]="'ProfileId'" class="text-center" style="width: 120px" [hidden]="!singleProfileSelect">
              {{ 'common.personal-information.profile-id' | translate | titlecase }}
              <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'Member'" class="text-center" style="width: 75px" [hidden]="!showMemberColumn">
              {{ 'members.member' | translate | titlecase }}
              <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'OrgInd'" class="text-center" style="width: 75px" [hidden]="!showOrgIndColumn">
              {{ 'profiles.org-ind' | translate | titlecase }}
              <p-sortIcon></p-sortIcon>
            </th>
            <th class="t-ac w-3">
              {{ 'common.edit' | translate | titlecase }}
            </th>
            <th [pSortableColumn]="'ASF'" [hidden]="!singleProfileSelect">
              {{ 'common.personal-information.profile-name' | translate | titlecase }}
              <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'ASF'" [hidden]="singleProfileSelect">
              {{ 'common.personal-information.profile-name' | translate | titlecase }}
              <p-sortIcon></p-sortIcon>
            </th>
            <th style="width: 12%">{{ 'profiles.search.related' | translate | titlecase }}</th>
            <th style="width: 13%" [pSortableColumn]="'MembershipLevel'">
              {{ 'profiles.search.membership-level' | translate | titlecase }}
              <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'Email'">
              {{ 'common.personal-information.email-address' | translate | titlecase }}
              <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'CustStatus'" [hidden]="!showCustStatusColumn" style="width: 10%">
              {{ 'profiles.search.status' | translate | titlecase }}
              <p-sortIcon></p-sortIcon>
            </th>
            <th [pSortableColumn]="'ProfileId'" class="text-center" style="width: 9%" [hidden]="singleProfileSelect">
              {{ 'common.personal-information.profile-id' | translate | titlecase }}
              <p-sortIcon></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr data-cy="trProfileSearchResult">
            <td class="text-center" [hidden]="singleProfileSelect">
              <input
                [(ngModel)]="item.Selected"
                (ngModelChange)="onProfileSelectedChange(item)"
                type="checkbox"
                data-cy="inputProfileSearchProfileSelect"
              />
            </td>
            <td class="text-center" [hidden]="!singleProfileSelect">
              <a [attr.href]="" (click)="singleProfileSelected(item)">{{ item.ProfileId }}</a>
            </td>
            <td class="text-center" [hidden]="!showMemberColumn">
              <input [(ngModel)]="item.Member" type="checkbox" disabled />
            </td>
            <td class="text-center" [hidden]="!showOrgIndColumn">
              <input [(ngModel)]="item.OrgInd" type="checkbox" disabled />
            </td>
            <td class="t-ac">
              <a (click)="onEditClicked(item.ProfileId)">
                <i class="pi pi-pencil"></i>
              </a>
            </td>
            <td [hidden]="!singleProfileSelect">
              <a [attr.href]="" (click)="singleProfileSelected(item)">{{ item.ReportName }}</a>
            </td>
            <td [hidden]="singleProfileSelect">
              <wl-profile-type-icon
                *ngIf="item && item.ProfileId"
                [isMember]="item.Member"
                [isOrg]="item.OrgInd"
                [profileId]="item.ProfileId"
              ></wl-profile-type-icon>
              <a (click)="singleProfileSelected(item)">{{ item.ReportName }}</a>
            </td>
            <td>
              <span>
                {{ item.MainContact != '' ? item.MainContact : item.RelatedOrg != '' ? item.RelatedOrg : '' }}
              </span>
            </td>
            <td data-cy="tdProfileSearchMembershipLevel">{{ item.MembershipLevel }}</td>
            <td style="overflow: hidden">
              <a [href]="'mailto:' + item.Email" target="_blank">{{ item.Email }}</a>
            </td>
            <td style="overflow: hidden" [hidden]="!showCustStatusColumn">{{ item.CustStatus }}</td>
            <td class="text-center" [hidden]="singleProfileSelect" data-cy="tdProfileSearchProfileId">{{ item.ProfileId }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer" *ngIf="!hideFooter">
          <tr>
            <td [attr.colspan]="columnCount + 1">
              <div [hidden]="isSearching" class="pull-right">
                {{ profileSearchComponentModel.profiles?.TotalCount }} {{ 'profiles.search.total-profiles' | translate | titlecase }}
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="columnCount + 1" class="text-center">
              {{ 'common.phrases.no-results-found' | translate | titlecase }}
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-progressSpinner *ngIf="isSearching"></p-progressSpinner>
      <div style="margin-top: -3.3em; float: left">
        <p-select [options]="pageSizeOptions" [(ngModel)]="selectedPageSize" (ngModelChange)="handlePageSizeChange($event)" appendTo="body">
        </p-select>
      </div>
    </div>
  </div>
  <div *ngIf="profileSelectorColumnMetaData && runProfileSelectorAdvancedSearch && showProfileSelectorGrid">
    <wl-profile-selector-results
      [advancedSearchParams]="profileSearchComponentModel.searchParams"
      [profileSelectorColumnMetaData]="profileSelectorColumnMetaData"
      [profileSelectorConfigSettings]="profileSearchConfigSettings"
      preventSelectAllReset="true"
      (columnConfigOpened)="manageColumnsComponent.showDialog()"
      (searchCleared)="clearProfiles()"
      [searchParams]="profileSearchComponentModel.searchParams"
      [initComplete]="initComplete"
    ></wl-profile-selector-results>
  </div>
  <p-dialog [(visible)]="showAffCodeAddDialog" modal="true" [closable]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
    <ng-template pTemplate="header">
      {{ 'profiles.search.affcode-add-header' | translate }}
    </ng-template>
    <wl-affcode-mass-add #wlAffCodeMassAdd hideTypes="true" showButtons="false"></wl-affcode-mass-add>
    <ng-template pTemplate="footer">
      <div class="mct-flex-gt-md mct-row-gt-md mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-gap-10">
        <button
          app-add-button
          class="atlas-btn atlas-btn-primary"
          [label]="'common.add' | translate | titlecase"
          (onClick)="massAddAffCodes()"
        ></button>
        <cancel-button [label]="'common.cancel' | translate | titlecase" (onClick)="cancelAffCodeAdd()"> </cancel-button>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="showAffCodeRemoveDialog" modal="true" [closable]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
    <ng-template pTemplate="header">
      {{ 'profiles.search.affcode-remove-header' | translate }}
    </ng-template>
    <wl-affcode-mass-add #wlAffCodeMassRemove hideTypes="true" showButtons="false"></wl-affcode-mass-add>
    <ng-template pTemplate="footer">
      <div class="mct-flex-gt-md mct-row-gt-md mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-gap-10">
        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-primary"
          icon="pi pi-minus"
          [label]="'common.remove' | translate | titlecase"
          (click)="massRemoveAffCodes()"
        ></button>
        <cancel-button [label]="'common.cancel' | translate | titlecase" (onClick)="cancelAffCodeRemove()"> </cancel-button>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="showAssignMembershipLevelDialog" modal="true" [closable]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
    <ng-template pTemplate="header">
      {{ 'profiles.search.assign-to-membership-header' | translate }}
    </ng-template>
    <p-select
      data-cy="selectProfileSearchAssignMembershipLevel"
      placeholder="{{ 'common.select' | translate | titlecase }}"
      [options]="membershipLevels"
      [style]="{ width: '100%' }"
      [(ngModel)]="selectedMembershipLevelId"
      appendTo="body"
    >
    </p-select>
    <p>
      {{ 'profiles.search.assign-to-membership-note' | translate }}
    </p>
    <ng-template pTemplate="footer">
      <div class="mct-flex-gt-md mct-row-gt-md mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-gap-10">
        <button
          type="button"
          data-cy="btnProfileSearchAssignMembershipLevel"
          class="atlas-btn atlas-btn-primary"
          (click)="massAssignMembershipLevels()"
          [disabled]="selectedMembershipLevelId == 0"
        >
          {{ 'profiles.search.assign-membership-level' | translate | uppercase }}
        </button>
        <cancel-button [label]="'common.cancel' | translate | uppercase" (onClick)="cancelAssignMembershipLevels()"> </cancel-button>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="showCreateMemberActivityDialog" modal="true" [closable]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
    <ng-template pTemplate="header">
      {{ 'profiles.search.create-activity-header' | translate | titlecase }}
    </ng-template>
    <wl-member-activity-search-action #memberActivityAction></wl-member-activity-search-action>
    <ng-template pTemplate="footer">
      <div class="mct-flex-gt-md mct-row-gt-md mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-gap-10">
        <button
          type="button"
          class="atlas-btn atlas-btn-primary"
          (click)="massCreateMemberActivity()"
          [disabled]="!memberActivityAction.valid"
        >
          {{ 'profiles.search.create-member-activities' | translate | uppercase }}
        </button>
        <cancel-button [label]="'common.cancel' | translate | uppercase" (onClick)="cancelCreateActivity()"> </cancel-button>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="showAssignUserDialog" modal="true" [closable]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
    <ng-template pTemplate="header">
      {{ 'profiles.search.assign-user-header' | translate | titlecase }}
    </ng-template>
    <wl-assign-user-search-action #assignUserAction></wl-assign-user-search-action>
    <ng-template pTemplate="footer">
      <div class="mct-flex-gt-md mct-row-gt-md mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-gap-10">
        <button
          type="button"
          class="atlas-btn atlas-btn-primary"
          (click)="massAssignUser()"
          [disabled]="assignUserAction.selectedUserId == 0"
        >
          {{ 'profiles.search.assign-user' | translate | uppercase }}
        </button>
        <cancel-button [label]="'common.cancel' | translate | uppercase" (onClick)="cancelAssignUser()"> </cancel-button>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="showSetStatusDialog" modal="true" [closable]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
    <ng-template pTemplate="header">
      {{ 'profiles.search.set-profile-status' | translate | titlecase }}
    </ng-template>
    <wl-set-status-search-action #setStatusAction></wl-set-status-search-action>
    <ng-template pTemplate="footer">
      <div class="mct-flex-gt-md mct-row-gt-md mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-gap-10">
        <button
          type="button"
          class="atlas-btn atlas-btn-primary"
          (click)="massSetStatus()"
          [disabled]="setStatusAction.selectedStatusId == 0"
        >
          {{ 'profiles.search.set-profile-status' | translate | uppercase }}
        </button>
        <cancel-button [label]="'common.cancel' | translate | uppercase" (onClick)="cancelSetStatus()"> </cancel-button>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="showCreateContactDialog" modal="true" [closable]="false" styleClass="atlas-dialog-s" [focusOnShow]="false">
    <ng-template pTemplate="header">
      {{ 'profiles.search.create-profile-contact-header' | translate | titlecase }}
    </ng-template>
    <wl-create-contact-search-action #createContactAction></wl-create-contact-search-action>
    <ng-template pTemplate="footer">
      <div class="mct-flex-gt-md mct-row-gt-md mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-gap-10">
        <button type="button" class="atlas-btn atlas-btn-primary" (click)="massCreateContact()" [disabled]="!createContactAction.valid">
          {{ 'profiles.search.create-contact-records' | translate | uppercase }}
        </button>
        <cancel-button [label]="'common.cancel' | translate | uppercase" (onClick)="cancelCreateContact()"> </cancel-button>
      </div>
    </ng-template>
  </p-dialog>

  <wl-create-task-search-action></wl-create-task-search-action>

  <p-dialog
    modal="true"
    [(visible)]="showEdit"
    [closable]="false"
    [minY]="350"
    styleClass="atlas-dialog-l"
    [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }"
  >
    <wl-profile-edit [preventLoad]="true" [hideSaveButtons]="true" [isModal]="true"></wl-profile-edit>
    <ng-template pTemplate="footer">
      <button class="atlas-btn atlas-btn-default mr-10" (click)="closeEdit()">{{ 'common.cancel' | translate | uppercase }}</button>
      <button class="atlas-btn atlas-btn-primary" (click)="saveOpenProfile()" [disabled]="isSaving || profileEditComponent?.isLoading">
        <span *ngIf="!isSaving && !profileEditComponent?.isLoading">{{
          'profiles.view.add-member.save-and-close' | translate | uppercase
        }}</span>
        <wl-busy [show]="isSaving || profileEditComponent?.isLoading"></wl-busy>
      </button>
    </ng-template>
  </p-dialog>
  <wl-add-referral-dialog></wl-add-referral-dialog>

  <wl-multiple-profile-invoice-modal></wl-multiple-profile-invoice-modal>

  <wl-profile-search-manage-columns
    (settingsSaved)="setSwapToV2OnNextSearch()"
    (settingsCleared)="settingsCleared()"
    #manageColumnsComponent
    [settings]="profileSearchConfigSettings"
  ></wl-profile-search-manage-columns>

  <p-confirmDialog
    #cd
    key="clearColumnsCD"
    header="{{ 'profiles.search.manage-columns.clear-columns' | translate | titlecase }}"
    icon="pi pi-exclamation-triangle"
  >
    <ng-template pTemplate="footer">
      <button class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
      <button class="atlas-btn atlas-btn-danger" (click)="cd.onAccept()">
        {{ 'common.delete' | translate | uppercase }}
      </button>
    </ng-template>
  </p-confirmDialog>
</div>
